export default {
    manifest_ids : [],
    trip_number : null,
    transport_orders : [],
}